import {
  string as yupString,
  object as yupObject,
} from 'yup';

import { ScenarioMember, ScenariosMembersListLookupData } from '@queries/scenarios';
import { countryCodes } from '../../../administration/obligationsPage/constants';
import { TAX_CURRENCIES } from '../../../shared/constants';
import { ValidateRowsFn } from '../../../shared/gridEdit/useEditableGridLogic';
import { validateBaseSchema } from '../../../shared/gridEdit/validators';


const ERROR_MESSAGES = {
  required: (fieldName: string) => () => `${fieldName} is required`,
  oneOf: (fieldName: string) => ({ values }: { values: string[] }) => `${fieldName} must be one of ${values}`,
};

const scenarioMembersSchema = ({ existingMembers }: { existingMembers: string[] }) => yupObject().shape({
  companyCode: yupString().notOneOf(existingMembers, 'Company Code already exists').max(13).required(),
  companyCodeDescription: yupString().required(),
  legalEntity: yupString().max(6).required(),
  businessUnit: yupString().required(),
  businessCode: yupString().required(),
  connectionName: yupString().required(),
  associatedLeCountryCode: yupString().required(),
  overrideTaxCurrency: yupString().when('countryCode', {
    is: (countryCode: string) => countryCode === countryCodes.US,
    then: yupString().oneOf([TAX_CURRENCIES.USD], `Tax Currency must be 'USD'`),
    otherwise: yupString().required(ERROR_MESSAGES.required('Tax Currency')),
  }),
  recordFTC: yupString().oneOf(['Y', 'N']).required(),
  functionalCurrency: yupString().required(),
  statCurrency: yupString().optional().nullable(),
});


export const validateScenarioMember: ValidateRowsFn<ScenarioMember, ScenariosMembersListLookupData> = (
  scenarioMember,
  context,
  allMembers
) => {
  const baseSchemaError = validateBaseSchema(scenarioMembersSchema({
    existingMembers: allMembers
      .filter(member => !member.meta.isAdded
        && !member.meta.isUpdated
        && member.companyCode !== scenarioMember.companyCode
      )
      .map(({ companyCode }) => companyCode),
  }), scenarioMember, context);

  return {
    errors: baseSchemaError,
  };
};
